var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({staticClass:"fbutton btn",class:_vm.classes,attrs:{"disabled":_vm.cDisabled}},'button',_vm.buttonProps,false),[_c('span',{staticClass:"fbutton_label"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }